export const environment = {
  production: true,
  apiUrl: 'https://production-api.certwalletapp.com/api',
  home: 'https://certwalletapp.com',
  env: 'production'
};
